import { Container } from 'react-bootstrap'
import { useRouteError } from 'react-router-dom'
import errBg from 'assets/images/errpage-404.svg'
import { useTranslation } from 'react-i18next'

function ErrorPage() {
	const { t } = useTranslation()

	const error = useRouteError()
	console.error(error)

	return (
		<Container fluid className="errpage-container">
			<img src={errBg} alt="404 not found page" />
			<h1>{t('err_page.title')}</h1>
			<p>{t('err_page.content')}</p>
		</Container>
	)
}

export default ErrorPage
